import { categories, education } from './londi-constants.js';
import _ from 'lodash';

export const fundingData = require('../assets/LONDI Förderalgorithmus aktuell.json').Foerderalgorithmus_MC_korrigier;

const COLUMN_HEADER_ID = 'C';
const NO_VALUE = -99; //Number.MIN_SAFE_INTEGER;
/*
this method calculates the child inputs + test results and returns a list of funding options
*/
// eslint-disable-next-line no-unused-vars
const dummy = {
  schoolGrade: 1,
  testTime: 2, //see enum testTimes
  germanSecondaryLanguage: true,
  screenResultsEstimated: false, //false to use blue/yellow/green results, or true if using true/false results (1 or 0)
  screeningResults: [
    { category: categories.Reading, result: 1 }, //result value is either from diagnosticResults or (1 / 0)
    { category: categories.Writing, result: 2 },
    { category: categories.Math, result: 3 },
  ],
  selectedTests: [
    {
      category: categories.Reading,
      testId: 61,
      results: [
        { competenceLevel: 1, title: 'Mengenerfassung', result: 20 },
        { competenceLevel: 1, title: 'Zahlerfassung ', result: 20 },
        { competenceLevel: 1, title: 'Mengenerfassung', result: 20 },
        { competenceLevel: 3, title: 'Addition/Subtraktion', result: 20 },
      ],
    },
    {
      category: categories.Math,
      testId: 29,
      results: [{ competenceLevel: 1, title: 'Summe DEMAT 5+', result: 20 }],
    },
  ],
};

export const getFundingMatching = (data, filterQuery) => {
  console.log('getFundingMatching', data);
  filterQuery = _.omitBy(filterQuery, (v) => v === null);
  filterQuery = _.mapValues(filterQuery, (v) => ['nein', 'ja'][v]);
  const filteredFundingData = _.filter(fundingData, filterQuery);
  console.log({ filteredFundingData, fundingData, filterQuery });
  const categoriesResult = [];
  const results = [];
  //we don't required test id - in case the results are without specific tests
  if (data.screeningResults.find((x) => x.results?.length > 0 && x.category === categories.Reading)) {
    categoriesResult.push(categories.Reading);
  }
  if (data.screeningResults.find((x) => x.results?.length > 0 && x.category === categories.Writing)) {
    categoriesResult.push(categories.Writing);
  }
  if (data.screeningResults.find((x) => x.results?.length > 0 && x.category === categories.Math)) {
    categoriesResult.push(categories.Math);
  }

  //convert values to int
  const competenceLevelPerCategory = {};
  data.screeningResults.forEach((x) => {
    x.results.forEach((y) => {
      if (!competenceLevelPerCategory[x.category]) {
        competenceLevelPerCategory[x.category] = [];
      }
      if (competenceLevelPerCategory[x.category].indexOf(y.competenceLevel) < 0) {
        competenceLevelPerCategory[x.category].push(y.competenceLevel);
      }
      y.result = parseInt(y.result); //must be a value

      //fix category for selected tests
      if (!y.category && x.category) {
        y.category = x.category;
      }
    });
  });

  //if some KS are missing, add them with -1 value
  Object.keys(competenceLevelPerCategory).forEach((category) => {
    const missingCompetenceLevels = _.difference([1, 2, 3, 4], competenceLevelPerCategory[category]);

    missingCompetenceLevels.forEach((level) => {
      data.screeningResults.push({
        category: parseInt(category),
        results: [
          {
            category,
            competenceLevel: level,
            result: -1,
          },
        ],
      });
    });
  });

  categoriesResult.forEach((category) => {
    //calculate the profile for each category
    //const fundingProfiles = getFundingProfiles(data.selectedTests);

    //filter the funding data
    let filterEducationColumn = '';
    switch (data.education) {
      case education.Elementary:
        filterEducationColumn = 'CN';
        break;
      case education.Middle:
        filterEducationColumn = 'CO';
        break;
      case education.High:
        filterEducationColumn = 'CP';
        break;
      default:
        throw new Error('invalid education area');
    }

    //filter by areas
    const categoryFilterColumn = getFilterColumnPerCategory(category);

    const educationFilter = filteredFundingData.filter((x) => x[filterEducationColumn] === 'ja');

    const filteredFundingDataPerCategory = [];
    filteredFundingDataPerCategory.push(
      ...educationFilter.filter(
        (x) => x[categoryFilterColumn] === 'ja' && !_.some(filteredFundingDataPerCategory, (y) => y[COLUMN_HEADER_ID] === x[COLUMN_HEADER_ID]) //don't add duplicates
      )
    );

    //rank the data by profile calculation
    const rankedFundingDataPerCategory = rankResultsByAbsoluteDiff(data, filteredFundingDataPerCategory, category);

    //format the results
    const catResults = rankedFundingDataPerCategory.map((x) => {
      return {
        title: x['G'],
        subtitle: x['H'],
        publisher: x['X'],
        year: x['V'],
        authors: getAuthors(x),
        link: x['Z'],
        classes: getTargetClassesForFunding(x),
        absoluteDiff: x.absoluteDiff,
        sumAbsoluteDiff: x.sumAbsoluteDiff,
        grade: x.grade,
        hauptscore: x.hauptscore,
        nebenscore: x.nebenscore,
        finalScore: x.finalScore,
        profiles: x.profiles,
        shortName: x['D'],
        testItem: x,
      };
    });

    results.push({ category, results: catResults });
  });


  console.log('getFundingMatching results:', results);
  return results;
};

const parseFloatGlobal = (value) => {
  return parseFloat(value.replace(',', '.'));
};

const getFilterColumnPerCategory = (category) => {
  switch (category) {
    case categories.Reading:
      return 'BZ';
    case categories.Writing:
      return 'CA';
    case categories.Math:
      return 'CB';
    default:
      throw new Error('invalid category');
  }
};

const getTargetClassesForFunding = (x) => {
  let classes = null;
  if (x['CO'] === 'ja' || x['CP'] === 'ja') {
    classes = [];
    if (x['CR'] === 'ja') {
      classes.push('1');
    }
    if (x['CS'] === 'ja') {
      classes.push('2');
    }
    if (x['CT'] === 'ja') {
      classes.push('3');
    }
    if (x['CU'] === 'ja') {
      classes.push('4');
    }
    if (x['CV'] === 'ja') {
      classes.push('5');
    }
    if (x['CW'] === 'ja') {
      classes.push('6');
    }
    if (x['CX'] === 'ja') {
      classes.push('>6');
    }
  }
  return classes;
};

const getAuthors = (x) => {
  const authors = [];
  for (let idx = 'I'; idx < 'U'; idx = stepOneLetter(stepOneLetter(idx))) {
    if (x[idx]?.trim().length > 0) {
      authors.push(`${x[idx]} ${x[stepOneLetter(idx)]}`);
    }
  }
  return authors;
};

const stepOneLetter = (letter) => {
  return String.fromCharCode(letter.charCodeAt(0) + 1);
};

const levelWeight = (level) => {
  switch (level) {
    case 1:
      return 4;
    case 2:
      return 3;
    case 3:
      return 2;
    case 4:
      return 1;
    default:
      throw new Error('invalid level');
  }
};

//input all tests with PRs, output: for each category,
const getFundingProfiles = (selectedTests) => {
  const fundingProfiles = {};
  selectedTests.forEach((test) => {
    const category = test.category;
    if (test.results.some((x) => x.result)) {
      if (!fundingProfiles[category]) {
        fundingProfiles[category] = { 1: {}, 2: {}, 3: {}, 4: {} };
      }
      //get the funding profile for the test, first get recodedPR
      for (let level = 1; level <= 4; level++) {
        const resultsPerLevel = test.results.filter((x) => x.competenceLevel === level && x.result > NO_VALUE);
        if (resultsPerLevel.length > 0) {
          const resultsAverage = _.meanBy(resultsPerLevel, 'result'); //find the average result for this level
          const recodedPR = recodePR(resultsAverage);
          fundingProfiles[category][level].recodedPR = recodedPR;
        }
      }
      //calculate for level 2 ONLY if KS2 has no value (use average of KS1 and KS3)
      const ks2RecodedPR = fundingProfiles[category][2]?.recodedPR;
      const ks2HasNoValue = ks2RecodedPR === undefined || ks2RecodedPR === null || ks2RecodedPR === NO_VALUE;
      if (ks2HasNoValue) {
        const ks1Value = fundingProfiles[category][1]?.recodedPR;
        const ks3Value = fundingProfiles[category][3]?.recodedPR;
        // Only calculate if both KS1 and KS3 have valid values
        if (ks1Value !== undefined && ks1Value !== NO_VALUE && ks3Value !== undefined && ks3Value !== NO_VALUE) {
          fundingProfiles[category][2].recodedPR = (ks1Value + ks3Value) / 2;
        }
      }

      //calculate the weight
      let allWeightedPR = 0;
      for (let level = 1; level <= 4; level++) {
        const item = fundingProfiles[category][level];
        if (item.recodedPR > NO_VALUE) {
          const weight = levelWeight(level); //Gewicht Förderstufe
          const weightedPR = item.recodedPR * weight; //calc table example: F3 * C3

          item.weightedPR = weightedPR;
          allWeightedPR += weightedPR;
        } else {
          item.weightedPR = NO_VALUE;
        }
      }

      //calculate the final profile
      for (let level = 1; level <= 4; level++) {
        const item = fundingProfiles[category][level];
        item.profileScore =
          item.weightedPR > NO_VALUE
            ? item.weightedPR / allWeightedPR //calc table example: G3 / (G3+G4+G5+G6)
            : NO_VALUE;

        //if the score is -1, there should be abs diff and no ranking
      }
    }
  });
  return fundingProfiles; //{category.level.profileScore}
};


const recodePR = (pr) => {
  if (pr < 0) {
    return NO_VALUE; // nicht vorhanden / no data (NO_VALUE = -99)
  }
  if (pr <= 10) {
    return 3;  // PR 0-10 = Hoher Förderbedarf (high support needed)
  }
  if (pr <= 20) {
    return 2;  // PR 11-20 = Mittlerer Förderbedarf (medium support)
  }
  if (pr <= 30) {
    return 1;  // PR 21-30 = Niedriger Förderbedarf (low support)
  }
  return 0;    // PR > 30 = Kein Förderbedarf (no support needed)
};

// Convert sum of absolute deviations to grade (Note 1-6)
const sumToGrade = (sum) => {
  if (sum < 0.25) return 1;
  if (sum < 0.5) return 2;   // 0.25 - 0.49
  if (sum < 0.75) return 3;  // 0.5 - 0.74
  if (sum < 1) return 4;     // 0.75 - 0.99
  if (sum <= 1.25) return 5; // 1 - 1.25
  return 6;                  // > 1.25
};
const getColumnForDiff = (category, level) => {
  switch (category) {
    case categories.Reading:
      switch (level) {
        case 1:
          return 'DK';
        case 2:
          return 'DL';
        case 3:
          return 'DM';
        case 4:
          return 'DO';
        default:
          throw new Error('invalid level');
      }
    case categories.Writing:
      switch (level) {
        case 1:
          return 'DK';
        case 2:
          return 'DL';
        case 3:
          return 'DN';
        case 4:
          return 'DP';
        default:
          throw new Error('invalid level');
      }
    case categories.Math:
      switch (level) {
        case 1:
          return 'DQ';
        case 2:
          return 'DR';
        case 3:
          return 'DS';
        case 4:
          return 'DT';
        default:
          throw new Error('invalid level');
      }
    default:
      throw new Error('invalid category');
  }
};

//“Absolute Abweichung
const rankResultsByAbsoluteDiff = (inputData, filteredFundingDataPerCategory, category) => {
  const selectedTests = inputData.screeningResults.filter((x) => x.results?.length > 0 && x.results.some((y) => y.result));
  const fundingProfiles = getFundingProfiles(selectedTests);

  //add absoluteDiff for all levels to each funding
  filteredFundingDataPerCategory.forEach((funding) => {
    funding.profiles = fundingProfiles;
    if (!funding.absoluteDiff) {
      funding.absoluteDiff = { 1: 0, 2: 0, 3: 0, 4: 0 };
    }
  });

  selectedTests
    .filter((x) => x.category === category)
    .forEach((test) => {
      for (let level = 1; level <= 4; level++) {
        const resultsPerLevel = test.results.filter((x) => x.competenceLevel === level);
        if (resultsPerLevel.length > 0 && resultsPerLevel.some((x) => x.result)) {
          //} > -1)) {
          const profileScore = fundingProfiles[category][level].profileScore;

          //find the funding matching for this category and level
          const diffColumn = getColumnForDiff(category, level);
          filteredFundingDataPerCategory.forEach((funding) => {
            const fundingDiffPoints = parseFloatGlobal(funding[diffColumn]);
            if (profileScore > NO_VALUE) {
              // Always calculate absolute difference, even if program value is 0
              // Example: |0.44 - 0| = 0.44 (not NO_VALUE)
              const diff = Math.abs(profileScore - fundingDiffPoints);
              funding.absoluteDiff[level] = diff;
            } else {
              funding.absoluteDiff[level] = NO_VALUE;
            }
          });
        }
      }
    });

  // NEW: Calculate sum of absolute deviations and convert to grade
  filteredFundingDataPerCategory.forEach((fundingItem) => {
    // Sum absolute deviations for KS1-KS4 (only if valid value exists)
    let sumAbsDiff = 0;
    let validKSCount = 0;

    for (let level = 1; level <= 4; level++) {
      const absDiff = fundingItem.absoluteDiff[level];
      if (absDiff !== NO_VALUE && absDiff !== undefined) {
        sumAbsDiff += absDiff;
        validKSCount++;
      }
    }

    // Add DU value (schwerpunkte_sonstiges)
    const duValue = parseFloatGlobal(fundingItem['DU']);
    if (!isNaN(duValue)) {
      sumAbsDiff += duValue;
    }

    fundingItem.sumAbsoluteDiff = sumAbsDiff;

    // Convert sum to grade (Note)
    fundingItem.grade = sumToGrade(sumAbsDiff);

    // Store scores for tiebreaker sorting
    fundingItem.hauptscore = parseFloatGlobal(fundingItem['DI']) || 0;
    fundingItem.nebenscore = parseFloatGlobal(fundingItem['DJ']) || 0;
    fundingItem.publicationYear = parseInt(fundingItem['V']) || 0;

    // Keep finalScore for backwards compatibility (use grade)
    fundingItem.finalScore = fundingItem.grade;
  });

  // Sort by: Grade ASC, then Hauptscore DESC, then Nebenscore DESC, then Year DESC
  return filteredFundingDataPerCategory.sort((a, b) => {
    // 1. Smaller grade = higher position
    if (a.grade !== b.grade) {
      return a.grade - b.grade;
    }
    // 2. Higher Hauptscore = higher position
    if (a.hauptscore !== b.hauptscore) {
      return b.hauptscore - a.hauptscore;
    }
    // 3. Higher Nebenscore = higher position
    if (a.nebenscore !== b.nebenscore) {
      return b.nebenscore - a.nebenscore;
    }
    // 4. More recent publication year = higher position
    return b.publicationYear - a.publicationYear;
  });
};

